import type * as React from 'react';
import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Skeleton } from '@crehana/ui';
import { useUITheme } from '@crehana/web';
// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { css } from 'styled-components';

const SkillXPSkeleton: FC<
  React.PropsWithChildren<{ 'data-testid'?: string }>
> = ({ 'data-testid': dataTestId }) => {
  const { isDark } = useUITheme();

  return (
    <Skeleton
      data-testid={dataTestId}
      className="w-full"
      css={css`
        height: 352px;
        ${({ theme }) => theme.breakpoints.up('sm')} {
          height: 424px;
        }
      `}
      isDark={isDark}
    />
  );
};

export default SkillXPSkeleton;
